import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import PopupModalContainer from "../Containers/PopupModalContainer";
import RectangleButton from "../Buttons/RectangleButton";
import { useCallback, useRef } from "react";
import QRCode from "react-qr-code";

type ShareQRCodeModalProps = {
  setIsVisible: (isVisible: boolean) => void;
  shareUrl: string; // the url the qr code will link to
  downloadLabel: string; // the label of the download png
};

const ShareQRCodeModal = (props: ShareQRCodeModalProps) => {
  const { setIsVisible, shareUrl, downloadLabel } = props;
  const qrCodeRef = useRef<HTMLDivElement>(null);

  const downloadQRCode = useCallback(() => {
    if (!qrCodeRef.current) return;

    const svg = qrCodeRef.current.querySelector("svg");
    if (!svg) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = `markit-qr-code-${downloadLabel}.png`;
      downloadLink.href = pngFile;
      downloadLink.click();
    };

    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  }, [downloadLabel]);

  return (
    <PopupModalContainer
      headerComp={
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span className="AboutSubtitle">Share QR Code</span>
        </div>
      }
      valueComp={
        <div
          className="ColumnNormal"
          style={{
            gap: 20,
            paddingBlock: "30px",
            width: "256px",
            margin: "0 auto",
          }}
        >
          <div ref={qrCodeRef} className="Centering">
            <QRCode value={shareUrl} />
          </div>
          <RectangleButton
            buttonLabel="Download QR Code"
            iconRight={<Icon icon="mdi:download" height={16} />}
            onPress={downloadQRCode}
            containerStyles={{
              backgroundColor: Colors.BLACK,
              color: Colors.WHITE,
              paddingBlock: 16,
              paddingInline: 12,
              width: "100%",
            }}
          />
        </div>
      }
      noExit
      closeOnOutsidePress
      closeModal={() => setIsVisible(false)}
    />
  );
};

export default ShareQRCodeModal;
